import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
// import { tokens } from "../../../../theme";
// import { tokens } from "../../../../../../theme";

// import Subheading from "../../../../../../components/theme/text/Subheading";

import { useTranslation } from "react-i18next";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import { tokens } from "../../../../../theme";
import { useSelector } from "react-redux";
import { UserPrivileges } from "../../../../../utils/permissions";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import ReturnPortalViewPort from "../../../../../components/portalbuilder/ViewPort";
import Subheading from "../../../../../components/theme/text/Subheading";
import { editableElements } from "../../../../../components/portalbuilder/config";
import { SHPBSpiral } from "../../../../../components/portalbuilder/Edittors/SHPBSpiral";
import { SHPBBackgroundColor } from "../../../../../components/portalbuilder/Edittors/SHPBBackgroundColor";
import { SHPBColor } from "../../../../../components/portalbuilder/Edittors/SHPBColor";
import { SHPBBorder } from "../../../../../components/portalbuilder/Edittors/SHPBBorder";
import { SHPBPaddingX } from "../../../../../components/portalbuilder/Edittors/SHPBPaddingX";
import Text from "../../../../../components/theme/text/Text";
import MPortalPreview from "../../../../../components/portalbuilder/MPortalPreview";
import { masterAssistMap } from "../../../../../components/portalbuilder/componentMaps";
// import Shbutton from "../../../../../../components/theme/buttons/Shbutton";

// import { useSelector } from "react-redux";
// import { editableElements } from "../../../../../../components/portalbuilder/config";
// import { SHPBBackgroundColor } from "../../../../../../components/portalbuilder/Edittors/SHPBBackgroundColor";
// import { SHPBBorder } from "../../../../../../components/portalbuilder/Edittors/SHPBBorder";
// import { SHPBColor } from "../../../../../../components/portalbuilder/Edittors/SHPBColor";
// import { SHPBPaddingX } from "../../../../../../components/portalbuilder/Edittors/SHPBPaddingX";
// import { SHPBSpiral } from "../../../../../../components/portalbuilder/Edittors/SHPBSpiral";
// import MPortalPreview from "../../../../../../components/portalbuilder/MPortalPreview";
// import ReturnPortalViewPort from "../../../../../../components/portalbuilder/ViewPort";
// import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
// import Text from "../../../../../../components/theme/text/Text";
// import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
// import { UserPrivileges } from "../../../../../../utils/permissions";

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <ButtonGroup version={2}>
            {props.hasModifyPermission && (
            <Shbutton
                isLoading={props.isLoading}
                className={"group-btn"}
                onClick={props.action}
                color={theme.palette.mode === "dark" ? "blue" : "primary"}
                variant="contained"
                // endIcon={<SaveIcon />}
            >
                {t('save')}
            </Shbutton>
            )}
        </ButtonGroup>
    );
};

const styles = (colors) => {
   return {
        header: {
            "@media screen and (max-width: 47.9375em)" : {
                display:"flex",
                mt:1.5,
                // pt:1,
                mb:2,
                background:`${colors.bg["tertiary"]}`,
                width:1,
                position:"relative",
            },
            title: {
                "@media screen and (max-width: 47.9375em)" : {
                    position:"absolute",
                    left:"50%",
                    top:"50%",
                    transform:"translate(-50%, -50%)",
                    pt:0,
                }
            }
        }
    }
}
const GenericReturnBuilderScreenWrapper = (props) => {
    const { t } = useTranslation();
    const apiRef = props.apiRef;
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const hasModifyPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_RETURN_MANAGE])
    );
    
    const [type, setType] = useState(props.map.section);

    const [valueMap, setValueMap] = useState(props.data);
    // const [fullMap, setFullMap] = useState(props.fullMap);
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            mobileActions: <GridActions hasModifyPermission={hasModifyPermission} action={saveDesign}/>,
            styles: styles(colors),
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    
    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }
    const handleClose = () => {
        setAddModalOpen(false);
    };

      const shouldChangeAll = true;
      

    // Function to toggle the visibility of an extra class
    const handleCheckboxChange = (extraClassKey) => {
        setValueMap(prevMap => {
            const updatedMap = { ...prevMap };

            // Set only the selected extra class to 'visible: true', and others to 'false'
            const extraClasses = updatedMap[type]?.extraClasses;
            Object.keys(extraClasses).forEach(classKey => {
                if (classKey === extraClassKey) {
                    extraClasses[classKey].visible = !extraClasses[classKey].visible;  // Toggle visibility
                } else {
                    extraClasses[classKey].visible = false; // Hide other extra classes
                }
            });

            return updatedMap;
        });
    };

    const updateValue = (type, item, value,groupKey) => {
        if(groupKey) {
            props.setTransformedData(oldMap => {
                const changedMap = { ...oldMap };
                const targetType = props.map[type];
            
                if (shouldChangeAll) {
                    for (let mapKey in changedMap) {
                        const masterEntries = Object.entries(masterAssistMap[mapKey]);
                        const updatedMap = { ...changedMap[mapKey] };
            
                        for (const [key, val] of masterEntries) {
                            if (val === targetType) {
                                updatedMap[key] = {
                                    ...updatedMap[key],
                                    editableValues: {
                                        ...updatedMap[key]?.editableValues,
                                        [groupKey]: {
                                            ...updatedMap[key]?.editableValues?.[groupKey],
                                            [item]: value
                                        }
                                    }
                                };
                            }
                        }
                        changedMap[mapKey] = updatedMap;
                    }
                } else {
                    const updatedMap = { ...changedMap[props.pageKey] };
                    updatedMap[type] = {
                        ...updatedMap[type],
                        editableValues: {
                            ...updatedMap[type]?.editableValues,
                            [groupKey]: {
                                ...updatedMap[type]?.editableValues?.[groupKey],
                                [item]: value
                            }
                        }
                    };
                    changedMap[props.pageKey] = updatedMap;
                }
                return changedMap;
            });
        }else {
            props.setTransformedData(oldMap => {
                const changedMap = {...oldMap};
                const targetType = props.map[type];
                if(shouldChangeAll){
                    for (let mapKey in changedMap) {
                        const masterEntries = Object.entries(masterAssistMap[mapKey]);
                        const updatedMap = {...changedMap[mapKey]};
                        for (const [key, val] of masterEntries) {
                            if (val === targetType) {
                                updatedMap[key] = {
                                    ...updatedMap[key],
                                    editableValues: {
                                        ...updatedMap[key]?.editableValues,
                                        [item]: value
                                    }
                                };
                            }
                        }
                        changedMap[mapKey] = updatedMap;
                    }
                } else {
                    const updatedMap = {...changedMap[props.pageKey]};
                    updatedMap[type] = {
                        ...updatedMap[type], 
                        editableValues: {
                            ...updatedMap[type]?.editableValues, 
                            [item]: value
                        }
                    };
                    // console.log("updatedMap",updatedMap);
                    changedMap[props.pageKey] = updatedMap;
                }
                return changedMap;
            })
        }
    };

    useEffect(() => {
        props.setTransformedData(oldmap => {
            const newMap = {...oldmap};
            newMap[props.pageKey] = valueMap;

            return newMap;
        });
    }, [valueMap])

    const saveDesign = () => {
        if(props.saveDesign){
            props.saveDesign();
        }
    }

    return (
        <Box
            sx={{
                pb:0,
                borderTopLeftRadius:"24px",
                borderTopRightRadius:"24px",
                height:1,
                // height: 'calc(100vh - 182px)',
                overflow: "hidden",
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                },
            }}
        >
            <Box
                sx={{
                    clipPath: 'inset(0 round 32px 32px 0 0)', // Match your border radius
                    height: '100%',
                    overflow: "hidden",
                }}
            >
                <Box
                    sx={{
                        overflow: "hidden", 
                        display:"flex",
                        background:theme.palette.mode === "dark" ? colors.grey[200]: colors.bg['tertiary'],
                        height:1,
                        borderTopLeftRadius:32,
                        borderTopRightRadius:32,
                        boxShadow:"0 0 19px rgba(49,65,95,.25)",
                        border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200]}`,
                        borderBottom:"none",
                        "@media screen and (max-width: 47.9375em) " : {
                            flexDirection:"column",
                            boxShadow:"none",
                            border:"none",
                            borderRadius:0,
                            overflow:"auto",
                            // display:"block",
                        }
                    }}
                >
                    {/* Canvas */}
                    <ReturnPortalViewPort

                        addModal={addModal}
                        setAddModalOpen={setAddModalOpen}
                        open={false}
                    >
                        <props.EditorComponent 
                            onClick={setType}
                            map={props.fullMap[props.pageKey]}
                            relationMenuData={props.relationMenuData}
                        />
                        {/* <EditOrderLinesToReturn 
                            onClick={setType}
                            map={valueMap}
                        /> */}
                    </ReturnPortalViewPort>
                  
                    {/* Editting stuff */}
                    <Box
                        sx={{
                            overflow:"hidden",
                            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                            width:300,
                            display:"flex",
                            flexDirection:"column",
                            boxShadow: "0 0 19px rgba(49,65,95,.25)",
                            pt:3,
                            "@media screen and (max-width: 47.9375em) " : {
                                mt:3,
                                flex:1,
                                width:"unset",
                                borderTopLeftRadius:24,
                                borderTopRightRadius:24,
                                // gap:1,
                            }
                        }}
                    >
                        <Subheading
                            allowOverflow
                            sx={{
                                px:3,
                            }}
                        >
                            {t("pb_"+type)}
                            <span
                                style={{
                                    color:colors.txt["secondary"]
                                }}
                            >
                                &nbsp;{t("edit")}

                            </span>
                        </Subheading>
                        <Box
                            sx={{
                                height:"calc(100% - 116px)",
                                overflow:"auto",
                                mt:2,
                                "@media screen and (max-width: 47.9375em) " : {
                                    height:"unset",
                                    overflow:"hidden",
                                    pb:10,
                                }
                            }}
                        >
                            <Box sx={{ }}>

                                {/* {props.fullMap[props.pageKey][type]?.extraClasses && Object.entries(props.fullMap[props.pageKey][type]?.extraClasses).length > 0 && 
                                    <Box sx={{mt:3, background:"lightorange"}}>
                                        {Object.entries(props.fullMap[props.pageKey][type]?.extraClasses).map(([extraClassKey, editableElementsForClass]) => (
                                            <Box key={extraClassKey} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={props.fullMap[props.pageKey][type]?.extraClasses?.[extraClassKey]?.visible || false} 
                                                    onChange={() => handleCheckboxChange(extraClassKey)}
                                                />
                                                <span>{extraClassKey}</span>
                                            </Box>
                                        ))}
                                    </Box>
                                } */}


                                <Box sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        gap:2
                                    }}
                                >

                                    {/* Check if any extra class is visible */}
                                    {Object.values(props.fullMap[props.pageKey][type]?.extraClasses || {}).some(extraClass => extraClass.visible) ? (
                                        // Render components based on the visible extra class
                                        Object.entries(props.fullMap[props.pageKey][type]?.extraClasses || {}).map(([extraClassKey, extraClassValues]) => {
                                            if (extraClassValues.visible) {
                                                return (
                                                    <Box>
                                                        
                                                        <Subheading>{extraClassKey}</Subheading>
                                                        {Object.keys(extraClassValues).map((item, index) => (
                                                            <Box key={index}>
                                                                {item === editableElements.SPIRAL && <SHPBSpiral />}
                                                                {item === editableElements.BACKGROUNDCOLOR && 
                                                                    <SHPBBackgroundColor />
                                                                }
                                                                {item === editableElements.COLOR && <SHPBColor />}
                                                                {item === editableElements.BORDER && <SHPBBorder />}
                                                                {item === editableElements.PADDING && <SHPBPaddingX />}
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                )
                                                
                                            }
                                            return null;
                                        })
                                    ) : (
                                        props.fullMap[props.pageKey][type]?.editableValues && (
                                            typeof Object.values(props.fullMap[props.pageKey][type].editableValues)[0] === 'string' ? 
                                                // ✅ Flat format
                                                Object.keys(props.fullMap[props.pageKey][type].editableValues)
                                                    .filter(item => Object.values(editableElements).includes(item))
                                                    .map((item, index) => (
                                                        <Box key={index} sx={{ px: 3 }}>
                                                            {item === editableElements.SPIRAL && (
                                                                <SHPBSpiral 
                                                                    key={type + item}
                                                                    value={props.fullMap[props.pageKey][type].editableValues[item]} 
                                                                    setValue={(value) => updateValue(type, item, value)}
                                                                />
                                                            )}
                                                            {item === editableElements.BACKGROUNDCOLOR && (
                                                                <SHPBBackgroundColor 
                                                                    key={type + item}
                                                                    value={props.fullMap[props.pageKey][type].editableValues[item]} 
                                                                    setValue={(value) => updateValue(type, item, value)}
                                                                />
                                                            )}
                                                            {item === editableElements.COLOR && (
                                                                <SHPBColor 
                                                                    key={type + item}
                                                                    value={props.fullMap[props.pageKey][type].editableValues[item]} 
                                                                    setValue={(value) => updateValue(type, item, value)}
                                                                />
                                                            )}
                                                        </Box>
                                                    ))
                                            : (
                                                
                                                Object.entries(props.fullMap[props.pageKey][type].editableValues).map(([groupKey, groupObj]) => (
                                                    <Box key={groupKey} sx={{ mb:2, }}>
                                                        {Object.values(editableElements).includes(groupKey) ?
                                                        
                                                            <Box 
                                                                // key={index}
                                                                sx={{
                                                                    px:3,
                                                                }}
                                                            >
                                                                {/* <Text>Hello {groupKey}</Text> */}
                                                                {groupKey === editableElements.SPIRAL && 
                                                                    <SHPBSpiral 
                                                                        key={type+groupKey}
                                                                        value={props.fullMap[props.pageKey][type].editableValues[groupKey]} 
                                                                        setValue={(value) => updateValue(type,groupKey,value)}
                                                                    />}
                                                                {groupKey === editableElements.BACKGROUNDCOLOR && 
                                                                    <SHPBBackgroundColor 
                                                                        key={type+groupKey}
                                                                        value={props.fullMap[props.pageKey][type].editableValues[groupKey]} 
                                                                        setValue={(value) => updateValue(type,groupKey,value)}
                                                                    />
                                                                }
                                                                {groupKey === editableElements.COLOR && 
                                                                    <SHPBColor 
                                                                        key={type+groupKey}
                                                                        value={props.fullMap[props.pageKey][type].editableValues[groupKey]} 
                                                                        setValue={(value) => updateValue(type,groupKey,value)}
                                                                    />
                                                                }
                                                            </Box>
                                                            :
                                                            <>
                                                                {Object.keys(groupObj)
                                                                    .filter(item => Object.values(editableElements).includes(item))
                                                                    .map(item => (
                                                                        <Box key={`${type}-${groupKey}-${item}`} sx={{ mb:1, px:3,}}>
                                                                            {item === editableElements.SPIRAL && (
                                                                                <SHPBSpiral
                                                                                    value={groupObj[item]}
                                                                                    setValue={(val) => updateValue(type, item, val, groupKey)}
                                                                                />
                                                                            )}
                                                                            {item === editableElements.BACKGROUNDCOLOR && (
                                                                                <SHPBBackgroundColor
                                                                                    value={groupObj[item]}
                                                                                    setValue={(val) => updateValue(type, item, val, groupKey)}
                                                                                />
                                                                            )}
                                                                            {item === editableElements.COLOR && (
                                                                                <SHPBColor
                                                                                    value={groupObj[item]}
                                                                                    setValue={(val) => updateValue(type, item, val, groupKey)}
                                                                                />
                                                                            )}
                                                                        </Box>
                                                                    )
                                                                )}
                                                            </>
                                                        }
                                                    {/* {console.log("editableElements[groupKey]",groupKey)} */}
                                                        
                                                    
                                                    </Box>
                                                ))
                                            )
                                        )
                                    )}
                                </Box>

                            </Box>
                        </Box>
                        <Box
                            sx={{
                                height:64,
                                px:3,
                                "@media screen and (max-width: 47.9375em) " : {
                                    display:"none",
                                }
                            }}
                        >
                            {/* <ButtonGroup */}
                            {hasModifyPermission && (
                            <Shbutton className={"group-btn"} color={"green"}
                                variant="contained" 
                                block
                                isLoading={props.styleUpdating}
                                onClick={() => saveDesign()}
                            >
                                {t("save")}
                            </Shbutton>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Box>
                
            <MPortalPreview addModal={addModal} setAddModalOpen={setAddModalOpen}  onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}>
                <props.PreviewComponent
                    map={valueMap}
                    relationMenuData={props.relationMenuData}
                />
            </MPortalPreview>
        </Box>
    )
};

export default GenericReturnBuilderScreenWrapper;